import { cn } from '@/shared/lib/utils';

interface LoadingStateProps {
  /** Lido por leitor de tela; some visualmente se `compact`. */
  label?: string;
  compact?: boolean;
  className?: string;
}

export function LoadingState({
  label = 'Carregando…',
  compact = false,
  className,
}: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        // Fica invisível por 300ms antes de aparecer. Com o cache do TanStack a
        // maioria das trocas de tela responde antes disso, e o spinner nunca
        // chega a existir — piscar "Carregando…" por 80ms é o que faz uma tela
        // RÁPIDA parecer instável.
        'flex animate-delayed-fade-in items-center justify-center gap-3 text-sm text-muted-foreground',
        compact ? 'py-2' : 'py-12',
        className,
      )}
    >
      <span
        aria-hidden="true"
        className="size-4 animate-spin rounded-full border-2 border-current border-t-transparent"
      />
      <span className={compact ? 'sr-only' : undefined}>{label}</span>
    </div>
  );
}

/** Bloco cinza para preencher o espaço de um conteúdo que ainda vai chegar. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} />;
}
